import { countryOptions, getCountryFlagUrl } from "./formatters";

const callingCodes: Record<string, string> = {
	Argentina: "+54",
	Australia: "+61",
	Belgium: "+32",
	Brazil: "+55",
	Canada: "+1",
	Cambodia: "+855",
	Chad: "+235",
	"Côte d'Ivoire": "+225",
	China: "+86",
	Germany: "+49",
	Denmark: "+45",
	Egypt: "+20",
	Fiji: "+679",
	France: "+33",
	Ghana: "+233",
	"Hong Kong": "+852",
	Hungary: "+36",
	Indonesia: "+62",
	India: "+91",
	Iraq: "+964",
	Italy: "+39",
	Jordan: "+962",
	Japan: "+81",
	Kazakhstan: "+7",
	Kenya: "+254",
	"South Korea": "+82",
	"Saudi Arabia": "+966",
	Libya: "+218",
	Morocco: "+212",
	Mongolia: "+976",
	Macao: "+853",
	Mexico: "+52",
	Malaysia: "+60",
	Nigeria: "+234",
	Netherlands: "+31",
	"New Zealand": "+64",
	Tahiti: "+689",
	Philippines: "+63",
	Pakistan: "+92",
	Poland: "+48",
	Portugal: "+351",
	"South Africa": "+27",
	Singapore: "+65",
	Spain: "+34",
	Thailand: "+66",
	"East Timor": "+670",
	Turkey: "+90",
	Taiwan: "+886",
	UAE: "+971",
	"United Kingdom": "+44",
	"United States": "+1",
	Vietnam: "+84",
};

const normalizedIso: Record<string, string> = {
	CBDA: "KH",
	KAZ: "KZ",
	KSA: "SA",
	RSA: "ZA",
	SP: "ES",
	UAE: "AE",
	UK: "GB",
	USA: "US",
};

const timezoneCountry: Record<string, string> = {
	"Asia/Ho_Chi_Minh": "VN",
	"Asia/Saigon": "VN",
	"Australia/Sydney": "AU",
	"Australia/Melbourne": "AU",
	"Australia/Brisbane": "AU",
	"Australia/Perth": "AU",
	"Asia/Singapore": "SG",
	"Asia/Kuala_Lumpur": "MY",
	"Asia/Manila": "PH",
	"Asia/Jakarta": "ID",
	"Asia/Bangkok": "TH",
	"Asia/Hong_Kong": "HK",
	"Asia/Tokyo": "JP",
	"Asia/Seoul": "KR",
	"Pacific/Auckland": "NZ",
	"Europe/London": "GB",
};

export type PhoneCountry = {
	name: string;
	iso: string;
	flag: string;
	flagUrl: string;
	callingCode: string;
};

export const phoneCountries: PhoneCountry[] = countryOptions
	.filter((country) => callingCodes[country.value])
	.map((country) => ({
		name: country.value,
		iso: normalizedIso[country.short] ?? country.short,
		flag: country.flag,
		flagUrl: getCountryFlagUrl(country.value),
		callingCode: callingCodes[country.value],
	}));

export const guessPhoneCountry = (): string => {
	if (typeof navigator === "undefined") return "";
	const localeRegion = navigator.language.match(/[-_]([A-Za-z]{2})$/)?.[1]?.toUpperCase();
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const guessedIso = timezoneCountry[timezone] || localeRegion;
	return phoneCountries.find((country) => country.iso === guessedIso)?.name || "";
};
